"use strict";

var _interopRequireDefault = require("/data/jenkins/workspace/test-e-youhuo/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.array.find.js");

require("core-js/modules/es.function.name.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/data/jenkins/workspace/test-e-youhuo/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/data/jenkins/workspace/test-e-youhuo/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _vuex = require("vuex");

var _breadcrumb = _interopRequireDefault(require("./components/breadcrumb"));

var _api = require("@/views/basic/company/api");

var _api2 = require("@/views/basic/customer/api");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    Breadcrumb: _breadcrumb.default
  },
  data: function data() {
    return {
      options: [],
      projectId: this.$store.state.project.projectId,
      projectName: this.$store.state.project.projectName,
      repoId: this.$store.state.project.repoId
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["sidebar", "avatar", "permissions_site", "project"])), (0, _vuex.mapState)(["settings"])), {}, {
    defaultSelectedKeys: function defaultSelectedKeys() {
      return this.permissions_site.map(function (item, index) {
        item["index"] = index + 2;
        return item;
      }).filter(function (item, index) {
        return item.currSite === true;
      }).map(function (item) {
        return item.index.toString();
      });
    }
  }),
  created: function created() {
    // 上游客户名称
    (0, _api2.listAll)().then(function (res) {
      var arr = [];

      if (res && res.data) {
        res.data.forEach(function (item) {
          arr.push({
            value: item.gsmc,
            label: item.gsmc
          });
        });
      }

      sessionStorage.setItem("customersList", JSON.stringify(arr));
    }); // 公司名称

    (0, _api.listAll)().then(function (res) {
      var arr = [];
      res.data.forEach(function (item) {
        arr.push({
          value: item.gsmc,
          label: item.gsmc
        });
      });
      sessionStorage.setItem("companiesList", JSON.stringify(arr));
    });
  },
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    logout: function logout() {
      var _this = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("auth/logout");

              case 2:
                if (_this.settings.need_project) {
                  _this.$store.commit("project/clearProject");
                }

                _this.$router.push("/auth/login?redirect=".concat(_this.$route.fullPath));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    switchSite: function switchSite(site) {
      var _this2 = this;

      if (!site.currSite) {
        this.$store.dispatch("auth/switchSite", site.id).then(function () {
          _this2.$store.commit("project/clearProject");

          localStorage.setItem("switchSite", "true");
          location.reload();
        }).catch(function () {});
      }
    },
    changeId: function changeId(id) {
      this.projectId = id;
      var obj = this.options.find(function (item) {
        return item.id === id;
      });
      this.$store.commit("project/updateProject", {
        projectId: this.projectId,
        projectName: obj.name,
        repoId: obj.fileRepoId
      });
      location.reload();
    }
  }
};
exports.default = _default;